import React from "react";
import AuthContainer from "../../../components/AuthContainer.js";
import { Box, Container, Typography } from "@mui/material";
import appcolors from "../../../constants/Colors.js";
import BackButton from "../../../components/BackButton/index.js";
import ForgotForm from "./ForgotForm.js";

const ForgotPassword = () => {
  return (
    <AuthContainer>
      <Box position={"absolute"} top={30} left={15}>
        <BackButton />
      </Box>
      <Container sx={{ maxWidth: "550px !important" }}>
        <Typography variant="auth_primary" component={"h1"}>
          Forgot Password
        </Typography>
        <Typography variant="auth_secondary" component={"p"} sx={{ mt: 0.5 }}>
          Welcome to{" "}
          <span style={{ color: appcolors.black, fontWeight: "bold" }}>
            Service Provider
          </span>{" "}
          CRM, Please give us user id
        </Typography>
        <ForgotForm />
      </Container>
    </AuthContainer>
  );
};

export default ForgotPassword;
